import { render, staticRenderFns } from "./purchasesTableMobile.vue?vue&type=template&id=6b89cf86&scoped=true&"
import script from "./purchasesTableMobile.vue?vue&type=script&lang=ts&"
export * from "./purchasesTableMobile.vue?vue&type=script&lang=ts&"
import style0 from "./purchasesTableMobile.vue?vue&type=style&index=0&id=6b89cf86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89cf86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VDataTable,VIcon,VPagination})
